export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.header =   json.header
      this.table =    json.table
      this.columns =  json.columns
      this.sundries  = json.sundries
      this.keys =     json.keys
      this.filters =  json.filters

      let x_ = 0
      this.columns.forEach(d=> {
        d.sx = x_
        if(d.align == 'start') d.x = x_ + this.table.padding
        if(d.align == 'middle') d.x = x_ + (d.width/2)
        if(d.align == 'end') d.x = x_ + d.width - this.table.padding
        d.mx = x_ + (d.width/2)
        x_ = x_ + d. width
        d.ex = x_
      })

      // Progress Position
      if(this.columns.find(f=> f.code == 'PROG')) {
        let prog = this.columns.find(f=> f.code == 'PROG')
        prog.sx = prog.sx + 10
        prog.mx = prog.mx + 10
        prog.ex = prog.ex + 10
      }
    },

  }
}